export default function Spinner() {
  return (
    <div className="flex items-center justify-center py-16">
      <div className="w-8 h-8 border-4 border-[#2E6096] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
